import Vue from 'vue';
import ApiGetOptions from '@/datatypes/api-get-options';
import ApiPostOptions from '@/datatypes/api-post-options';
import ApiHeaders from '@/datatypes/api-headers';
import axios from 'axios';
import router from '@/router/index';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

axios.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    console.log(error);
    const { status } = error.response;
    if (status === 401) {
      if (router.currentRoute.path !== '/login') {
        router.push('/login');
      }
      throw error;
    } else {
      throw error;
    }
  },
);

export default class ApiService {
  protected getKey() {
    return Vue.prototype.$cookies.get('PLSKey');
  }

  protected getSecret() {
    return Vue.prototype.$cookies.get('PLSSecret');
  }

  protected setCredentials(key, secret) {
    Vue.prototype.$cookies.set('PLSKey', key, undefined, undefined, process.env.VUE_APP_COOKIE_DOMAIN);
    Vue.prototype.$cookies.set('PLSSecret', secret, undefined, undefined, process.env.VUE_APP_COOKIE_DOMAIN);
  }

  protected clearCredentials() {
    Vue.prototype.$cookies.remove('PLSKey', undefined, process.env.VUE_APP_COOKIE_DOMAIN);
    Vue.prototype.$cookies.remove('PLSSecret', undefined, process.env.VUE_APP_COOKIE_DOMAIN);
  }

  callPublic(options: ApiGetOptions | ApiPostOptions) {
    options.setHeaders(new ApiHeaders(
      {
        'Accept-Version': 'v2',
      },
    ));

    return this.makeRequest(options);
  }

  call(options: ApiGetOptions | ApiPostOptions) {
    options.setHeaders(new ApiHeaders(
      {
        id: this.getKey(),
        key: this.getSecret(),
      },
    ));

    return this.makeRequest(options);
  }

  private makeRequest(options) {
    return axios(options.render());
  }

  private goLogin() {
    if (router.currentRoute.path !== '/login') {
      router.push('/login');
    }
  }
}
